import { useEffect, useState } from "react";
import logo from "../../assets/images/logo.png";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useTranslation } from "react-i18next";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";
import ProgressWithPercentage from "./ProgressWithPercentage";
import PhoneInputWithCountry from "./PhoneInputWithCountry";

export default function AuthCallback() {
  const navigateWithLang = useLanguageNavigate();
  const direction = useLanguageDirection();
  const { t } = useTranslation();
  const [name, setSetName] = useState("");
  const [countryName, setCountryName] = useState("");
  const [flag, setFlag] = useState(null);
  // const [isPhoneNumbur, setIsPhoneNumbur] = useState(true);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    setToken(token);
    const formattedName = (params.get("name") || "")
      .split("-")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

    const formattedCountry = (params.get("countryName") || "")
      .split("-")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

    const formattedFlag = params.get("flag") === "true";
    if (token && formattedFlag) {
      localStorage.setItem("accessToken", token);
      // console.log(formattedFlag);
    }
    setSetName(formattedName);
    setCountryName(formattedCountry);
    setFlag(formattedFlag);
  }, []);

  useEffect(() => {
    if (flag === true) {
      const timer = setTimeout(() => {
        const token = localStorage.getItem("accessToken");

        if (token) navigateWithLang("/my-account/dashboard");
        else navigateWithLang("/login");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [flag, navigateWithLang]);

  // console.log(countryName);
  // console.log(typeof flag);
  // console.log(flag);
  return (
    <div
      className="relative flex items-center justify-center h-screen z-[99999] bg-yellow-50"
      dir={direction}
    >
      <div className="md:min-w-[60%] min-w-[80%]">
        <div className="flex flex-col items-center max-w-[98%] mx-auto px-4 py-8 text-center bg-black border border-gray-100 shadow-lg md:px-14 md:py-16 lg:max-w-lg rounded-2xl">
          <img
            src={logo}
            alt="Logo"
            className="mb-6 max-w-[80%] md:w-[19rem] animate-bounce"
          />
          {flag ? (
            <>
              <h2 className="mb-2 text-2xl font-semibold text-white">
                {t("welcomeGoogle")} {name}
              </h2>
              <p className="mb-6 text-gray-300">{t("loadingDataFromGoogle")}</p>
              <p className="mb-2 text-gray-300 whitespace-nowrap">
                {t("addPhoneAndAddressNotice")}
              </p>
              <p className="text-gray-300 ">{t("throughAccountPage")}</p>
              <ProgressWithPercentage />
            </>
          ) : (
            <>
              <h2 className="mb-2 text-2xl font-semibold text-white">
                {t("welcomeGoogle")}
              </h2>
              <p className="mb-6 text-gray-300">{t("enterPhoneNumber")}</p>
              <PhoneInputWithCountry
                defaultCountryName={countryName}
                placeholder={t("enterPhoneNumber")}
                token={token}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
